import type { IconPropInterface, MLPVersion } from '@nextgen-web-framework/all';
import { OperationType } from '@commerce-identity-webcomponents/sdk';
import { PasswordVisible } from '../amway-password-field/types/propTypes';

export interface PasswordInputFieldStateType extends IconPropInterface {
  type: string;
}

export type IconName = IconPropInterface;
export type PasswordInputFieldProps = {
  label?: string;
  name: keyof PasswordVisible;
  disabled?: boolean;
  mlpVersion?: MLPVersion;
  value?: {
    createPassword: string;
    confirmPassword: string;
  };
  error?: string;
  forceError?: boolean | string;
  onInputChangeCallback?: (value: React.ChangeEvent<HTMLInputElement>) => unknown;
  required?: boolean;
  isPasswordUsePrev?: boolean;
};

export interface CurrentPasswordInputProps {
  name: keyof PasswordVisible;
  label?: string;
  placeholder?: string;
  onInputChangeCallback?: (value: React.ChangeEvent<HTMLInputElement>) => unknown;
  required?: boolean;
  setError?: (error: string) => unknown;
  error?: string;
  forceError?: boolean | string;
  mlpVersion?: MLPVersion;
  checkUsernameConfig?: OperationType;
  component?: string;
  placeholderForCreatePassword?: string;
  placeholderForCreatePasswordError?: string;
  placeholderForConfirmPassword?: string;
  placeHolderForConfirmPasswordError?: string;
  createPasswordError?: string;
  confirmPasswordError?: string;
  passwordCombinationError?: string;
  setIsButtonDisable?: (e: boolean) => void;
}

export interface PasswordWithConfirmProps {
  mlpVersion?: MLPVersion;
  className?: string;
  name: keyof PasswordVisible;
  label?: string;
  placeholderForCreatePassword?: string;
  placeholderForCreatePasswordError?: string;
  placeholderForConfirmPassword?: string;
  placeHolderForConfirmPasswordError?: string;
  createPasswordError?: string;
  confirmPasswordError?: string;
  passwordCombinationError1?: string;
  passwordCombinationError2?: string;
  passwordCombinationError3?: string;
  passwordCombinationErrorHeading?: string;
  value?: {
    createPassword: string;
    confirmPassword: string;
  };
  setIsButtonDisable?: (e: boolean) => void;
  onInputChangeCallback?: (value: React.ChangeEvent<HTMLInputElement>) => unknown;
  required?: boolean;
  setError?: (error: string) => unknown;
  error?: string;
  forceError?: boolean | string;
}

export type callbackInputType = {
  username?: string;
  requestId?: string;
};
export interface AmwayPasswordInputProps {
  mlpVersion?: MLPVersion;
  label?: string;
  placeholder?: string;
  name: keyof PasswordVisible;
  checkUsernameConfig?: OperationType;
  component?: string;
  onInputChangeCallback?: (value: React.ChangeEvent<HTMLInputElement>) => unknown;
  onPasswordChange?: (password: string) => void;
  onPasswordMeetsMinimumChange?: (meetsMinimum: boolean) => void;
  required?: boolean;
  setError?: (error: string) => unknown;
  error?: string;
  forceError?: boolean | string;
  placeholderForCreatePassword?: string;
  placeholderForCreatePasswordError?: string;
  placeholderForConfirmPassword?: string;
  placeHolderForConfirmPasswordError?: string;
  createPasswordError?: string;
  confirmPasswordError?: string;
  passwordCombinationError?: string;
  isPasswordUsePrev?: boolean;
  value?: {
    createPassword: string;
    confirmPassword: string;
  };
  setIsButtonDisable?: (e: boolean) => void;
  className?: string;
  disabled?: boolean;
}

export enum ComponentType {
  WITH_CONFIRM = 'passwordWithConfirm',
  WITHOUT_CONFIRM = 'passwordWithoutConfirm',
}
